import { combineReducers } from '@reduxjs/toolkit'

import allProductsSearch from './AllProductsSearch/allProductsSearchSlice'
import quickSearch from './QuickSearch/quickSearchSlice'

export default combineReducers({
	allProductsSearch,
	quickSearch
})